import React, { useState, useEffect } from 'react';
import { fetchWatchData, deleteWatch, purgeAllWatches } from '../../adminApi';
import { useGameContext } from '../../context/GameContext';
import styles from '../../styles/WatchDataPanel.module.css';

const WatchDataPanel = () => {
  const [activeTab, setActiveTab] = useState('clientCache');
  const [watchData, setWatchData] = useState([]);
  const { watchedPicks } = useGameContext();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    if (activeTab === 'clientCache') {
      // Transform watchedPicks into the same format as the database data
      const transformedWatches = watchedPicks.map(watch => ({
        userId: watch.userId,
        week: watch.weekNumber,
        gameId: watch.gameId,
        picktype: watch.pickType,
        watchLine: watch.watchLine,
        dbParity: true // We can update this when we implement database comparison
      }));
      setWatchData(transformedWatches);
      setIsLoading(false);
    } else if (activeTab === 'database') {
      loadDatabaseWatchData();
    }
  }, [activeTab, watchedPicks]);

  const loadDatabaseWatchData = async () => {
    try {
      const response = await fetchWatchData();
      setWatchData(response.data || []);
    } catch (error) {
      console.error('Error loading watch data:', error);
      setWatchData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteWatch = async (userId, gameId, pickType, week) => {
    await deleteWatch(userId, gameId, pickType, week);
    if (activeTab === 'database') {
      loadDatabaseWatchData();
    }
  };

  const handlePurgeAllWatches = async () => {
    await purgeAllWatches();
    if (activeTab === 'database') {
      loadDatabaseWatchData();
    }
  };

  return (
    <div className={styles.watchDataPanel}>
      <h2>Watch Data</h2>
      <div className={styles.tabs}>
        <button 
          className={activeTab === 'clientCache' ? styles.activeTab : ''} 
          onClick={() => setActiveTab('clientCache')}
        >
          Client Cache
        </button>
        <button 
          className={activeTab === 'database' ? styles.activeTab : ''} 
          onClick={() => setActiveTab('database')}
        >
          Database
        </button>
      </div>
      <button className={styles.purgeButton} onClick={handlePurgeAllWatches}>
        Purge All Watches
      </button>
      {isLoading ? (
        <p>Loading watches...</p>
      ) : watchData.length === 0 ? (
        <p>No watches found.</p>
      ) : (
        <table className={styles.watchDataTable}>
          <thead>
            <tr>
              <th>User</th>
              <th>Week</th>
              <th>Game ID</th>
              <th>Pick Type</th>
              <th>Watch Line</th>
              <th>DB Parity</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {watchData.map((watch, index) => (
              <tr key={index}>
                <td>{watch.userId}</td>
                <td>{watch.week}</td>
                <td>{watch.gameId}</td>
                <td>{watch.picktype}</td>
                <td>{watch.watchLine}</td>
                <td>{watch.dbParity ? 'True' : 'False'}</td>
                <td>
                  <button onClick={() => handleDeleteWatch(watch.userId, watch.gameId, watch.picktype, watch.week)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default WatchDataPanel;
